<template>
  <div>
    <div>
      <div class="col-11 text-right menu-locale">
        <base-button
          size="sm"
          type="primary"
          v-if="this.$i18n.locale == 'en'"
          @click="en()"
          >EN</base-button
        >
        <base-button
          size="sm"
          type="neutral"
          v-if="this.$i18n.locale == 'th'"
          @click="en()"
          >EN</base-button
        >
        <base-button
          size="sm"
          type="primary"
          v-if="this.$i18n.locale == 'th'"
          @click="th()"
          >TH</base-button
        >
        <base-button
          size="sm"
          type="neutral"
          v-if="this.$i18n.locale == 'en'"
          @click="th()"
          >TH</base-button
        >
      </div>
    </div>
    <!-- Header -->
    <div class="header  py-7 py-lg-6 pt-lg-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-md-8 px-5">
              <img src="img/dtac.png" alt="" style="width:30%;height:auto;" />
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100"></div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-8">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5" >
              <div class="text-center text-muted mb-4">
                <small>{{ $t("auth.resetpassword") }}</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    error="error"
                    :placeholder="$t('profile.password_new')"
                    v-model="model.password"
                    autocomplete="off"
                    type="password"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    error="error"
                    :placeholder="$t('profile.password_confirm')"
                    v-model="model.password_confirm"
                    autocomplete="off"
                    type="password"
                  >
                  </base-input>
         

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-info"
                      >{{ $t("auth.resetpassword") }}</base-button
                    >
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueI18n from "vue-i18n";
import { mapActions, mapGetters, matGetters } from "vuex";
import swal from "sweetalert2";
const qs = require("querystring");

export default {
  data() {
    return {
      model: {
        token: "",
        password: "",
        password_confirm: "",
      },
    };
  },
  mounted() {
      this.model.token = this.$route.query.token
  },
  methods: {
    ...mapActions({
      ResetPassword: "Auth/ResetPassword"
    }),
    en() {
      this.$i18n.locale = "en";
    },
    th() {
      this.$i18n.locale = "th";
    },
    onSubmit() {
      this.ResetPassword(this.model)
        .then(res => {
            console.log(res)
          swal.fire({
            title: this.$t("profile.reset_password_success"),
            text: ``,
            size: `sm`,
            icon: "success",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
            
            this.$router.push("/login"); 
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.auth.reset_password_fail"),
            text: ``,
            size: `sm`,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.menu-locale {
  padding-top: 0.25in;
}
</style>
